import styled from 'styled-components'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { respondAbove } from 'styles/mediaQueries'

export const Wrapper = styled(Box)`
    position: relative;
    ${Text} {
        a {
            margin-top: 2px;
            color: ${({ theme }) => theme.colors.primary_500};
            text-decoration: underline;
        }
    }
    .description-item {
        display: inline-flex;
        align-items: center;
        vertical-align: middle;
        margin-right: 8px;

        ::before {
            display: inline-block;
            margin-right: 8px;
            width: 3px;
            height: 3px;
            border-radius: 50px;
            background-color: ${({ theme }) => theme.colors.grayscale_700};
            content: '';
        }
        :first-of-type {
            @media (min-width: 375px) {
                ::before {
                    display: none;
                }
            }
        }
    }
    a:not(:only-child) {
        display: inline-block;
        padding-top: 4px;
    }
    a:focus-visible {
        color: ${({ theme }) => theme.colors.secondary_500};
    }
`

export const Decor = styled.div`
    position: absolute;
    top: 0;
    left: -18px;
    right: -18px;
    overflow: hidden;

    @media ${respondAbove.xl} {
        left: -42px;
        right: -42px;
    }
    svg {
        display: block;
        width: 100%;

        @media (max-width: 414px) {
            margin-left: -5px;
            width: calc(100% + 10px);
        }
    }
`

export const PriceWrapper = styled(Box)`
    @media ${respondAbove.xs} {
        min-width: 90px;
    }
`

export const QuantityPriceWrapper = styled(Box)`
    flex-shrink: 0;
`

export const Description = styled(Text)`
    && a {
        font-family: ${({ theme }) => theme.fonts.text};
        color: ${({ theme }) => theme.colors.grayscale_900};
    }

    &:focus-within a {
        color: ${({ theme }) => theme.colors.secondary_500};
    }
`
